import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useDeleteTask } from '../../../hooks/useHome';
import { useToast } from '../../../hooks/useToast';
import css from '../HomePage.module.css';

interface Props {
  taskID: string;
  onClose: () => void;
  onDeleted: () => void;
}

export default function DeleteConfirmModal({ taskID, onClose, onDeleted }: Props) {
  const deleteTask = useDeleteTask();
  const { showToast } = useToast();

  function handleConfirm() {
    deleteTask.mutate(taskID, {
      onSuccess: () => {
        showToast('Task deleted', 'success');
        onDeleted();
      },
      onError: () => {
        showToast('Failed to delete task', 'error');
      },
    });
  }

  function handleOverlayClick(e: React.MouseEvent) {
    if (e.target === e.currentTarget) onClose();
  }

  return (
    <div className={css.modalOverlay} onClick={handleOverlayClick} style={{ zIndex: 2000 }}>
      <div className={`${css.modal} ${css.deleteModal}`}>
        <div className={css.modalHeader}>
          <h4 className={css.modalTitle}>Confirm Delete</h4>
        </div>
        <div className={css.modalBody}>
          <p>Please confirm you want to delete this task.</p>
        </div>
        <div className={css.modalFooter}>
          <button className={`${css.btnSm} ${css.btnOutline}`} onClick={onClose}>
            Cancel
          </button>
          <button
            className={`${css.btnSm} ${css.btnDanger}`}
            onClick={handleConfirm}
            disabled={deleteTask.isPending}
          >
            {deleteTask.isPending ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin /> Deleting...
              </>
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
